import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createUserRegistration } from '../../actions/user';
import { Card, CardContent, CardHeader } from '@mui/material';
import DatePickerWrapper from '../../components/Reusable/FormFieldTypes/DatePickerWrapper';
import {
  Avatar,
  Button,
  CssBaseline,
  Typography,
  Container,
  Grid,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import InputField from '../Reusable/InputField';
import { SignUpForm } from '../../enums/SignUpEnums';
import SelectFieldWrapper from '../../components/Reusable/FormFieldTypes/SelectFieldWrapper';

const SignUp = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { error } = user;
  const [singUpRequestData, setSingUpRequestData] = useState({
    firstName: '',
    lastName: '',
    username: '',
    password: '',
    confirmPassword: '',
    address: '',
    phoneNumber: '',
    email: '',
    name: '',
    role: {
      id: 2,
    },

    companyName: '',
    registrationNumber: '',
    registrationDate: '',
    pib: '',
    bankAccount: '',
    modeOfTransport: '',
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setSingUpRequestData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const displayMutualFields = (error) => {
    return (
      <>
        <Grid item sm={6}>
          <InputField
            id={'signup-firstName'}
            name="firstName"
            placeholder={SignUpForm.signupPlaceholderFirstname}
            onChange={onChange}
            required
            value={singUpRequestData.firstName}
            error={error?.firstName}
            autoFocus
          />
        </Grid>
        <Grid item sm={6}>
          <InputField
            id={'signup-lastName'}
            name="lastName"
            placeholder={SignUpForm.signupPlaceholderLastname}
            onChange={onChange}
            required
            value={singUpRequestData.lastName}
            error={error?.lastName}
          />
        </Grid>
        <Grid item sm={12} style={{ marginTop: '-0.5rem' }}>
          <InputField
            id={'signup-address'}
            name="address"
            placeholder={SignUpForm.signupPlaceholderAddress}
            onChange={onChange}
            value={singUpRequestData.address}
            error={error?.address}
          />
          <InputField
            id={'signup-phoneNumber'}
            name="phoneNumber"
            placeholder={SignUpForm.signupPlaceholderPhone}
            onChange={onChange}
            value={singUpRequestData.phoneNumber}
            error={error?.phoneNumber}
          />
          <InputField
            id={'signup-email'}
            name="email"
            placeholder={SignUpForm.signupPlaceholderEmail}
            onChange={onChange}
            required
            value={singUpRequestData.email}
            error={error?.email}
          />
          <InputField
            id={'signup-username'}
            name="username"
            placeholder={SignUpForm.signupPlaceholderUserName}
            onChange={onChange}
            required
            value={singUpRequestData.username}
            error={error?.username}
          />
          <InputField
            id={'signup-password'}
            type="password"
            name="password"
            placeholder={SignUpForm.signupPlaceholderPassword}
            onChange={onChange}
            required={true}
            value={singUpRequestData.password}
            error={error?.password}
          />
          <InputField
            id={'signup-confirmPassword'}
            type="password"
            name="confirmPassword"
            placeholder={SignUpForm.signupPlaceholderConfirmPassword}
            onChange={onChange}
            required={true}
            value={singUpRequestData.confirmPassword}
            error={error?.confirmPassword}
          />
        </Grid>
      </>
    );
  };

  const displayCompanyFields = (error) => {
    return (
      <>
        <Grid item xs={12}>
          <InputField
            id="company-name"
            name="companyName"
            placeholder={SignUpForm.signupPlaceholderCompanyName}
            onChange={onChange}
            value={singUpRequestData.companyName}
            error={error?.companyName}
          />
        </Grid>

        <Grid item xs={12}>
          <SelectFieldWrapper
            field={{
              name: 'modeOfTransport',
              label: SignUpForm.signupModeOfTransport,
              options: [
                { value: 'Komercijalni prevoz', label: SignUpForm.signupCommercial },
                { value: 'Sopstveni prevoz', label: SignUpForm.signupOwnTransport },
                { value: 'Specijalni prevoz', label: SignUpForm.signupSpecial },
              ],
            }}
            value={singUpRequestData.modeOfTransport}
            onChange={(name, value) =>
              setSingUpRequestData((prev) => ({
                ...prev,
                [name]: value,
              }))
            }
            error={error?.modeOfTransport}
          />
        </Grid>

        <Grid item xs={12}>
          <InputField
            id="registration-number"
            name="registrationNumber"
            placeholder={SignUpForm.signupPlaceholderRegistrationNumber}
            onChange={onChange}
            value={singUpRequestData.registrationNumber}
            error={error?.registrationNumber}
          />
        </Grid>

        <Grid item xs={12}>
          <DatePickerWrapper
            field={{
              name: 'registrationDate',
              label: 'Registration date',
            }}
            value={singUpRequestData.registrationDate}
            onChange={(name, value) =>
              setSingUpRequestData((prev) => ({
                ...prev,
                [name]: value,
              }))
            }
            error={error?.registrationDate}
          />
        </Grid>

        <Grid item xs={12}>
          <InputField
            id="pib"
            name="pib"
            placeholder={SignUpForm.signupPlaceholderPib}
            onChange={onChange}
            value={singUpRequestData.pib}
            error={error?.pib}
          />
        </Grid>

        <Grid item xs={12}>
          <InputField
            id="bank-account"
            name="bankAccount"
            placeholder={SignUpForm.signupPlaceholderBankAccount}
            onChange={onChange}
            value={singUpRequestData.bankAccount}
            error={error?.bankAccount}
          />
        </Grid>
      </>
    );
  };

  const formatDate = (date) => {
    if (!date) return null;

    return date.format('DD.MM.YYYY');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      companyName,
      registrationNumber,
      registrationDate,
      pib,
      bankAccount,
      ...userData
    } = singUpRequestData;

    const newRegistration = {
      ...userData,
      companyName,
      registrationNumber,
      registrationDate: formatDate(singUpRequestData.registrationDate),
      pib,
      bankAccount,

    };
 console.log("Payload koji se šalje:", newRegistration);
    dispatch(createUserRegistration(newRegistration, history));
  };

  return (
    <div className="wrapper-fade-in">
      <Container component="main" maxWidth="md" className="mt-3">
        <br></br>
        <CssBaseline />
        <div className="paper-login">
          <Avatar className="avatar-login">
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {SignUpForm.signupFormTitle}
          </Typography>
          <form className="form-login" onSubmit={handleSubmit}>
            <Grid container spacing={2}>

              {/* LEFT CARD - USER INFO */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardHeader title={SignUpForm.signupPersonalInfoTitle} />
                  <CardContent>
                    <Grid container spacing={1}>
                      {displayMutualFields(error)}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* RIGHT CARD - COMPANY INFO */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardHeader title={SignUpForm.signupCompanyInfoTitle} />
                  <CardContent>
                    <Grid container spacing={1}>
                      {displayCompanyFields(error)}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* SUBMIT BUTTON */}
              <Grid item xs={12} md={4} className="m-auto">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className="submit-login mt-4 mb-3"
                >
                  {SignUpForm.signupFormSubmitButton}
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default SignUp;
